import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen } from '@fortawesome/pro-solid-svg-icons';

import FilterTopbar from 'components/search_page/filter_topbar';
import FilterButton from 'components/search_sidebar/filter_button';

import CustomFieldsFilter from './custom_fields_filter';
import ResearchFiltersContainer from './research_filters_container';
import ResearchFilterRow from './research_filter_row';
import ResearchCurrentFiltersGroup from './research_current_filters_group';
import PropertyGroupFilter from './property_group_filter';
import SaleOrLeaseFilterGroup from './sale_or_lease_filter_group';
import ResearchTagsFilter from './research_tags_filter';
import MobileFilterTopBar from './mobile_filter_topbar';

import { clearFiltersIfEmpty, changeSearchText } from '../store/actions/query';
import { delayRetrieveRecords, retrieveRecords } from '../store/actions/search';
import { retrieveGroups } from '../store/actions/properties';

import { isPresent } from 'helpers/string_helpers';

export class ResearchFilterTopbar extends React.Component {
  static propTypes = {
    canGroup: PropTypes.bool.isRequired,
    clearFiltersIfEmpty: PropTypes.func.isRequired,
    delayRetrieveRecords: PropTypes.func,
    edgeCrm: PropTypes.bool,
    groups: PropTypes.array,
    pageData: PropTypes.shape({
      currentPage: PropTypes.number.isRequired,
      itemCount: PropTypes.number.isRequired,
      itemSingularLabel: PropTypes.string.isRequired,
      pageSize: PropTypes.number.isRequired,
      totalCount: PropTypes.number.isRequired
    }),
    propertyCount: PropTypes.number.isRequired,
    renderPageCount: PropTypes.object,
    retrieveGroups: PropTypes.func.isRequired,
    retrieveRecords: PropTypes.func.isRequired,
    saleFilter: PropTypes.object.isRequired,
    searchText: PropTypes.string.isRequired,
    selectedGroupIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    totalUngroupedCount: PropTypes.number.isRequired,

    onChangeSearchText: PropTypes.func.isRequired,
    onDisplayFilters: PropTypes.func.isRequired
  };

  componentDidMount() {
    const {
      clearFiltersIfEmpty,
      retrieveGroups,
      retrieveRecords
    } = this.props;

    clearFiltersIfEmpty();
    retrieveRecords();
    retrieveGroups();
  }

  get selectedGroups() {
    const { groups, selectedGroupIds, totalUngroupedCount } = this.props;

    if (selectedGroupIds[0] === 'ungrouped') {
      return [{ id: 'ungrouped', name: 'Ungrouped', count: totalUngroupedCount }];
    } else {
      return groups.filter(group => selectedGroupIds.includes(group.id));
    }
  }

  get groupFilterLabel() {
    const selectedGroups = this.selectedGroups;

    if (selectedGroups.length === 0) {
      return 'All Properties';
    } else if (selectedGroups.length === 1) {
      return selectedGroups[0].name;
    } else {
      return `${selectedGroups.length} Groups`;
    }
  }

  get groupFilterCount() {
    const selectedGroups = this.selectedGroups;

    if (selectedGroups.length === 0) {
      return this.props.propertyCount;
    } else if (selectedGroups[0].id === 'ungrouped') {
      return selectedGroups[0].count;
    } else {
      return selectedGroups.reduce((count, group) => count + group.count, 0);
    }
  }

  render() {
    const { onDisplayFilters } = this.props;
    return (
      <React.Fragment>
        <FilterTopbar>
          <div>{this.renderFilters()}</div>
          <div className="hidden-xs hidden-sm">
            <div className="left-buffer-md container-fluid">
              <ResearchCurrentFiltersGroup />
            </div>
          </div>
        </FilterTopbar>
        <MobileFilterTopBar onDisplayFilters={onDisplayFilters}/>
      </React.Fragment>
    );
  }

  renderFilters() {
    const { canGroup, groups } = this.props;

    return (
      <ResearchFilterRow edgeCrm={this.props.edgeCrm}>
        {canGroup && groups.length > 0 && this.renderGroupButton()}
        <ResearchFiltersContainer />
        {this.renderSaleButton()}
        {!this.props.edgeCrm && <ResearchTagsFilter/>}
        <CustomFieldsFilter/>
      </ResearchFilterRow>
    );
  }

  renderSaleButton() {
    const { saleFilter } = this.props;
    const filtersApplied = Object.keys(saleFilter).some((k) => {
      return (isPresent(saleFilter[k]) && k !== "leaseRateUnits");
    });

    return (
      <FilterButton
        filtersApplied={filtersApplied}
        label="Sale/Lease"
        name="sale-lease-filter"
      >
        <SaleOrLeaseFilterGroup />
      </FilterButton>
    );
  }

  renderGroupFilterLabel() {
    let count;
    if (this.selectedGroups.length <= 1) {
      count = (
        <span className="left-buffer-sm">
          ({this.groupFilterCount})
        </span>
      );
    }

    return (
      <React.Fragment>
        <FontAwesomeIcon
          className="right-buffer-md folder-icon"
          icon={faFolderOpen}
        />
        <span className="group-text">
          {this.groupFilterLabel}
          {count}
        </span>
      </React.Fragment>
    );
  }

  renderGroupButton() {
    return (
      <FilterButton
        filtersApplied={false}
        label={this.renderGroupFilterLabel()}
        name="groups-filter"
      >
        <PropertyGroupFilter />
      </FilterButton>
    );
  }
}

const mapStateToProps = state => ({
  canGroup: state.ui.canGroup,
  groups: state.properties.groups,
  saleFilter: state.query.saleFilter,
  searchText: state.query.searchText,
  selectedGroupIds: state.query.researchGroupIds,
  totalUngroupedCount: state.search.meta.totalUngroupedCount
});

const mapDispatchToProps = {
  clearFiltersIfEmpty,
  delayRetrieveRecords,
  retrieveGroups,
  retrieveRecords,

  onChangeSearchText: changeSearchText,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResearchFilterTopbar);
